export interface FinancialReport {
  id: string;
  label: string;
  file: string;
}

export interface FinancialYear {
  year: number;
  reports: FinancialReport[];
}

export const financialStatementsConfig: FinancialYear[] = [
  {
    year: 2021,
    reports: [
      {
        id: "2021-pnl",
        label: "Profit & Loss 2021",
        file: "/financial-statements/2021/profit_and_loss.pdf",
      },
      {
        id: "2021-gl",
        label: "General Ledger 2021",
        file: "/financial-statements/2021/general_ledger.pdf",
      },
      {
        id: "2021-tb",
        label: "Trial Balance 2021",
        file: "/financial-statements/2021/trial_balance.pdf",
      },
      {
        id: "2021-bs",
        label: "Balance Sheet 2021",
        file: "/financial-statements/2021/balance_sheet.pdf",
      },
    ],
  },
  {
    year: 2022,
    reports: [
      {
        id: "2022-pnl",
        label: "Profit & Loss 2022",
        file: "/financial-statements/2022/profit_and_loss.pdf",
      },
      {
        id: "2022-gl",
        label: "General Ledger 2022",
        file: "/financial-statements/2022/general_ledger.pdf",
      },
      {
        id: "2022-tb",
        label: "Trial Balance 2022",
        file: "/financial-statements/2022/trial_balance.pdf",
      },
      {
        id: "2022-bs",
        label: "Balance Sheet 2022",
        file: "/financial-statements/2022/balance_sheet.pdf",
      },
    ],
  },
];
